export class VisibleEvent {
  constructor(
    public eventName: string,
    public famcode: string,
    public role: string,
    public enabled: boolean = false,
  ) {}
}
